import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  get appBaseUrl(): string {
    return window.__env?.app_base_url ?? '';
  }

  get apiUrl(): string {
    return window.__env?.api_url ?? '';
  }

  get clientId(): string {
    return window.__env?.client_id ?? '';
  }

  get env(): string {
    return window.__env?.env ?? '';
  }

  get production(): boolean {
    return window.__env?.production ?? false;
  }

  get authRedirectUrl(): string {
    return window.__env?.auth_redirect_url ?? '';
  }

  get homeUrl(): string {
    return window.__env?.home_url ?? '';
  }

  get callCenterAppUrl(): string {
    return window.__env?.call_center_app_url ?? '';
  }

  get callCenterApiUrl(): string {
    return window.__env?.call_center_api_url ?? '';
  }

  get saleDateEditWindowDays(): number {
    return window.__env?.sale_date_edit_window_days ?? 2;
  }

  get saleDateMinDaysBefore(): number {
    return window.__env?.sale_date_min_days_before ?? 2;
  }

  get enableService(): boolean {
    return window.__env?.enable_service ?? false;
  }

  get enablePayments(): boolean {
    return window.__env?.enable_payments ?? false;
  }

  get enableTotalBalanceDue(): boolean {
    return window.__env?.enable_total_balance_due ?? false;
  }

  /** ImageKit hostname whose image URLs get resized thumbnails; empty disables thumbnail transforms. */
  get imageKitHost(): string {
    return (window.__env?.imagekit_host ?? '').trim();
  }
}
